import { render, staticRenderFns } from "./list.vue?vue&type=template&id=206c7fb3&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&lang=css&"
import style1 from "./list.vue?vue&type=style&index=1&id=206c7fb3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c7fb3",
  null
  
)

export default component.exports